import { GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import React from "react"
import { ArticleContentComponentContainer } from "../utils"

const ConstructionMethodList = ({ construction_method_blogposts }) =>
  construction_method_blogposts?.map(
    ({ slugline, title, thumbnail }, index) => {
      return (
        <div
          className="is-bordered article-teaser-list-item mb-5"
          key={`post-link-number-${index}`}
        >
          <Link to={`/fachzeitschriften/umweltbau/bauverfahren/${slugline}`}>
            <div className="columns is-mobile">
              <div className="column is-4 pr-4-desktop pr-0-mobile pl-0-desktop is-flex">
                <div
                  className="article-teaser-small-image my-auto"
                  style={{ maxHeight: 150 }}
                >
                  {thumbnail ? (
                    <GatsbyImage
                      alt={title}
                      image={
                        thumbnail.localFile.childImageSharp.gatsbyImageData
                      }
                      style={{
                        height: "100%",
                        width: "100%",
                        margin: "auto",
                        maxHeight: 200,
                      }}
                    />
                  ) : null}
                  <div className="image-overlay-black-30 is-hidden-touch"></div>
                </div>
              </div>

              <div className="column is-flex is-flex-direction-column pl-2">
                <p className="has-text-umweltbau my-4">Bauverfahren erklärt</p>
                <p className="title is-4 is-size-5-mobile mb-5">{title}</p>
              </div>
            </div>
          </Link>
        </div>
      )
    }
  )

export const ConstructionMethodsHorizontal = ({
  construction_method_blogposts,
  in_article,
}) => {
  return in_article ? (
    <ArticleContentComponentContainer
      {...{
        custom_classes: "my-6 py-0",
        attributes: { "data-nosnippet": true },
      }}
    >
      <ConstructionMethodList {...{ construction_method_blogposts }} />
    </ArticleContentComponentContainer>
  ) : (
    <div className="mt-5 mx-3">
      <ConstructionMethodList {...{ construction_method_blogposts }} />
    </div>
  )
}
